import type { CSSProperties } from 'react';
import type { LottieOptions } from 'lottie-react';

/** Normalizes CRA/webpack JSON imports (`module` vs `module.default`). */
export function normalizeLottieAnimationData(module: unknown): unknown {
    if (module == null) {
        return null;
    }
    if (typeof module === 'object' && 'default' in module) {
        return (module as { default: unknown }).default;
    }
    return module;
}

export function isValidLottieAnimationData(data: unknown): data is NonNullable<LottieOptions['animationData']> {
    const normalized = normalizeLottieAnimationData(data);
    return (
        typeof normalized === 'object' &&
        normalized !== null &&
        Array.isArray((normalized as { layers?: unknown }).layers)
    );
}

export type SafeLottieProps = {
    animationData: unknown;
    loop?: boolean;
    style?: CSSProperties;
};
